export const atomicArgu = {
  properties: {
    coverImage: 'https://atomicdata.dev/Folder/wp8ame4nqf/urHO7G8FKm',
  },
};
